/* eslint-disable */
import { API_GET_DATA_ATTENDANCE_BY_ROOMID, API_GET_DETAIL_ROOM, API_GET_ROLE_BY_ROOMID, API_MAP, API_UPDATE_BY_ROOMID, API_UPDATE_ONE_BY_ROOMID, GET_CONFIGS_SYSTEM, GET_ONE_CONFIG, JOIN_NOW } from "../../../modules/API";
import { CONFIG_CODE_GET } from "../base/constants/default";
import axiosClient from "./axiosClient";
class apiManagerRoom {
    joinNow() {
        return axiosClient.post(JOIN_NOW);
    }
    getDetailRoom(data) {
        return axiosClient.get(API_GET_DETAIL_ROOM + '/' + data);
    }
    getAttendance(data) {
        return axiosClient.get(API_GET_DATA_ATTENDANCE_BY_ROOMID + data);
    }
    getConfig(code) {
        return axiosClient.get(GET_ONE_CONFIG + '?code=' + code);
    }
    getConfigs() {
        return axiosClient.get(`${GET_CONFIGS_SYSTEM}?configsCode=${CONFIG_CODE_GET.join()}`);
    }
    getRoleByRoomId(roomId) {
        return axiosClient.get(API_GET_ROLE_BY_ROOMID + '/' + roomId);
    }
    getUserRole(data) {
        return axiosClient.post(API_GET_ROLE_BY_ROOMID, data);
    }
    updateOneByRoomId(data) {
        return axiosClient.post(API_UPDATE_ONE_BY_ROOMID, data);
    }
    updateByRoomId(roomId, data) {
        return axiosClient.post(API_UPDATE_BY_ROOMID + roomId, data);
    }
    checkLimitedUser(roomId, username) {
        return axiosClient.get(API_MAP.ROOM.CHECK_LIMITED_USER + '/' + roomId + '?username=' + username);
    }
    getTotalUsers(roomId) {
        return axiosClient.get(`${API_MAP.ROOM.GET_TOTAL_USERS}/${roomId}`);
    }
    getTotalMeeting(roomId) {
        return axiosClient.get(API_MAP.ROOM.GET_TOTAL_MEETING + "?roomId=" + roomId);
    }
    getRoleRoom(roomId, userId) {
        return axiosClient.get(API_MAP.ROOM.GET_ROLE_ROOM + "?roomId=" + roomId + "&userId=" + userId);
    }
    checkLimitMeeting(roomId) {
        return axiosClient.get(API_MAP.ROOM.CHECK_LIMIT_MEETING + "?roomId=" + roomId);
    }
    getLimitUsers(roomId) {
        return axiosClient.get(API_MAP.ROOM.GET_LIMIT_USERS + "?roomId=" + roomId);
    }
    updatePassword(body) {
        return axiosClient.post(API_MAP.ROOM.UPDATE_PASSWORD, body);
    }
}
export default new apiManagerRoom();
